module.exports = __webpack_public_path__ + "static/logo_predict-1518c56e888f998a4fb74cb21e440ca8.svg";